(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initYasOnsaleTabs(root) {
      if (!root || root.getAttribute('data-yas-tabs-ready') === 'true') return;

      root.setAttribute('data-yas-tabs-ready', 'true');

      var buttons = root.querySelectorAll('[data-yas-tab-button]');
      var panels = root.querySelectorAll('[data-yas-tab-panel]');
      var viewAll = root.querySelector('[data-yas-tabs-view-all]');

      if (!buttons.length || !panels.length) return;

      function activateTab(button) {
        var targetId = button.getAttribute('data-yas-tab-target');
        var targetPanel = root.querySelector('#' + targetId);

        buttons.forEach(function (btn) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-selected', 'false');
        });

        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
          panel.setAttribute('hidden', '');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');

        if (targetPanel) {
          targetPanel.classList.add('is-active');
          targetPanel.removeAttribute('hidden');
        }

        if (viewAll) {
          var newUrl = button.getAttribute('data-view-all-url');
          if (newUrl) viewAll.setAttribute('href', newUrl);
        }
      }

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          activateTab(button);
        });
      });
    }

    function initAllYasOnsaleTabs(scope) {
      var roots = (scope || document).querySelectorAll('[data-yas-onsale-tabs]');
      roots.forEach(initYasOnsaleTabs);
    }

    initAllYasOnsaleTabs(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAllYasOnsaleTabs(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (function () {
    function initYasCollection(root) {
      var filterToggle = root.querySelector('[data-yas-filter-toggle]');
      var filterPanel = root.querySelector('[data-yas-filter-panel]');
      var sortSelect = root.querySelector('[data-yas-sort-select]');
      var filterForm = root.querySelector('[data-yas-filter-form]');
      var loadMoreWrap = root.querySelector('[data-yas-load-more]');
      var grid = root.querySelector('[data-yas-collection-grid]');

      if (filterToggle && filterPanel) {
        filterToggle.addEventListener('click', function () {
          var isOpen = filterPanel.hasAttribute('hidden') === false;

          if (isOpen) {
            filterPanel.setAttribute('hidden', '');
            filterToggle.setAttribute('aria-expanded', 'false');
          } else {
            filterPanel.removeAttribute('hidden');
            filterToggle.setAttribute('aria-expanded', 'true');
          }
        });
      }

      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sortSelect.value);
          window.location.href = url.toString();
        });
      }

      if (filterForm) {
        filterForm.addEventListener('submit', function (e) {
          e.preventDefault();

          var sortInput = filterForm.querySelector('[data-yas-filter-sort-input]');
          if (sortInput && sortSelect) sortInput.value = sortSelect.value;

          var params = new URLSearchParams();
          var formData = new FormData(filterForm);

          formData.forEach(function (value, key) {
            if (value !== '') params.append(key, value);
          });

          var base = window.location.pathname;
          window.location.href = base + '?' + params.toString();
        });
      }

      if (loadMoreWrap && grid) {
        var btn = loadMoreWrap.querySelector('.yas-collection__load-more-btn');

        if (btn) {
          btn.addEventListener('click', function (e) {
            var nextUrl = loadMoreWrap.getAttribute('data-next-url');
            if (!nextUrl) return;

            e.preventDefault();

            btn.setAttribute('aria-busy', 'true');

            fetch(nextUrl)
              .then(function (res) {
                return res.text();
              })
              .then(function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                var newGrid = doc.querySelector('[data-yas-collection-grid]');
                var newLoadMore = doc.querySelector('[data-yas-load-more]');

                if (newGrid) {
                  Array.prototype.forEach.call(newGrid.children, function (child) {
                    grid.appendChild(child);
                  });
                }

                if (newLoadMore) {
                  var newNextUrl = newLoadMore.getAttribute('data-next-url');
                  var newShowing = newLoadMore.querySelector('.yas-collection__showing');
                  var currentShowing = loadMoreWrap.querySelector('.yas-collection__showing');

                  if (newShowing && currentShowing) {
                    currentShowing.textContent = newShowing.textContent;
                  }

                  if (newNextUrl) {
                    loadMoreWrap.setAttribute('data-next-url', newNextUrl);
                    btn.setAttribute('href', newNextUrl);
                  } else {
                    btn.remove();
                  }
                } else {
                  btn.remove();
                }
              })
              .catch(function () {
                window.location.href = nextUrl;
              })
              .finally(function () {
                btn.removeAttribute('aria-busy');
              });
          });
        }
      }
    }

    document.querySelectorAll('[data-yas-collection]').forEach(initYasCollection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yas-main-collection"]) return;
  try {
    
  (function () {
    function initYasCollection(root) {
      var filterToggle = root.querySelector('[data-yas-filter-toggle]');
      var filterPanel = root.querySelector('[data-yas-filter-panel]');
      var sortSelect = root.querySelector('[data-yas-sort-select]');
      var filterForm = root.querySelector('[data-yas-filter-form]');
      var loadMoreWrap = root.querySelector('[data-yas-load-more]');
      var grid = root.querySelector('[data-yas-collection-grid]');

      if (filterToggle && filterPanel) {
        filterToggle.addEventListener('click', function () {
          var isOpen = filterPanel.hasAttribute('hidden') === false;
          if (isOpen) {
            filterPanel.setAttribute('hidden', '');
            filterToggle.setAttribute('aria-expanded', 'false');
          } else {
            filterPanel.removeAttribute('hidden');
            filterToggle.setAttribute('aria-expanded', 'true');
          }
        });
      }

      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sortSelect.value);
          window.location.href = url.toString();
        });
      }

      if (filterForm) {
        filterForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var sortInput = filterForm.querySelector('[data-yas-filter-sort-input]');
          if (sortInput && sortSelect) sortInput.value = sortSelect.value;

          var params = new URLSearchParams();
          var formData = new FormData(filterForm);
          formData.forEach(function (value, key) {
            if (value !== '') params.append(key, value);
          });

          var base = window.location.pathname;
          window.location.href = base + '?' + params.toString();
        });
      }

      // Progressive "Load More" — fetch next page and append, fall back to <a href> nav on failure
      if (loadMoreWrap && grid) {
        var btn = loadMoreWrap.querySelector('.yas-collection__load-more-btn');
        if (btn) {
          btn.addEventListener('click', function (e) {
            var nextUrl = loadMoreWrap.getAttribute('data-next-url');
            if (!nextUrl) return; // let default link navigation happen
            e.preventDefault();

            btn.setAttribute('aria-busy', 'true');
            fetch(nextUrl)
              .then(function (res) { return res.text(); })
              .then(function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                var newGrid = doc.querySelector('[data-yas-collection-grid]');
                var newLoadMore = doc.querySelector('[data-yas-load-more]');

                if (newGrid) {
                  Array.prototype.forEach.call(newGrid.children, function (child) {
                    grid.appendChild(child);
                  });
                }

                if (newLoadMore) {
                  var newNextUrl = newLoadMore.getAttribute('data-next-url');
                  var newShowing = newLoadMore.querySelector('.yas-collection__showing');
                  var currentShowing = loadMoreWrap.querySelector('.yas-collection__showing');
                  if (newShowing && currentShowing) currentShowing.textContent = newShowing.textContent;

                  if (newNextUrl) {
                    loadMoreWrap.setAttribute('data-next-url', newNextUrl);
                    btn.setAttribute('href', newNextUrl);
                  } else {
                    btn.remove();
                  }
                } else {
                  btn.remove();
                }
              })
              .catch(function () {
                window.location.href = nextUrl;
              })
              .finally(function () {
                btn.removeAttribute('aria-busy');
              });
          });
        }
      }
    }

    document.querySelectorAll('[data-yas-collection]').forEach(initYasCollection);
  })();

  } catch(e) { console.error(e); }
})();
})();
